import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  assignedDevices: [],
  deviceOptions: [],
};

const buildingDevicesSlice = createSlice({
  name: "buildingDevices",
  initialState,
  reducers: {
    setAssignedDevices(state, action) {
      state.assignedDevices = action.payload;
    },
    setDeviceOptions(state, action) {
      state.deviceOptions = action.payload;
    },
    updateDeviceInState(state, action) {
      const updatedDevice = action.payload;
      const index = state.assignedDevices.findIndex(
        (device) => device.deviceID === updatedDevice.deviceID
      );
      if (index !== -1) {
        state.assignedDevices[index] = updatedDevice;
      }
    },
    addDeviceToState(state, action) {
      state.assignedDevices.push(action.payload);
    },
    removeDeviceFromState(state, action) {
      const deviceID = action.payload;
      state.assignedDevices = state.assignedDevices.filter(
        (device) => device.deviceID !== deviceID
      );
    },
  },
});

export const {
  setAssignedDevices,
  setDeviceOptions,
  updateDeviceInState,
  addDeviceToState,
  removeDeviceFromState,
} = buildingDevicesSlice.actions;

export default buildingDevicesSlice.reducer;
